import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((_theme) => ({
  addressForm: {
    marginBottom: '20px',
    '& .MuiFormHelperText-root': {
      fontStyle: 'italic',
      marginLeft: 0,
    },
  },
}))
